import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { LayoutAlignDirective, LayoutDirective } from '@ngbracket/ngx-layout/flex';

@Component({
  selector: 'mng-loading',
  imports: [LayoutDirective, LayoutAlignDirective, MatProgressSpinner],
  templateUrl: './mng-loading.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MngLoadingComponent {}
